import { render, staticRenderFns } from "./simscripteditor.vue?vue&type=template&id=4e99f648&"
import script from "./simscripteditor.vue?vue&type=script&lang=js&"
export * from "./simscripteditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports